import {inject, Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../../../../environments/environment';
import {
  ScreeningSettingsDTO,
  ScreeningSettingsServiceTypes,
  ScreeningSettingsTestResearchDTO,
  ScreeningSettingsTestResearchResponseDTO,
  SimpleQueryDTO
} from '../../dto/screening-settings';
import {map} from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class ScreeningSettingsService {
  private readonly http: HttpClient = inject(HttpClient);
  private readonly apiUrl = environment.apiBaseUrl + '/project';


  testCountQuery(projectId: number, query: ScreeningSettingsTestResearchDTO): Observable<number> {
    if (!projectId) {
      throw new Error('ProjectId is required');
    }
    return this.http.post<ScreeningSettingsTestResearchResponseDTO>(`${this.apiUrl}/${projectId}/research/query/test`, query).pipe(
      map((res: ScreeningSettingsTestResearchResponseDTO) => res.result)
    );
  }

  getSetting(projectId: number): Observable<ScreeningSettingsDTO> {
    if (!projectId) {
      throw new Error('ProjectId is required');
    }
    return this.http.get<ScreeningSettingsDTO>(`${this.apiUrl}/${projectId}/screening-settings`);
  }

  getSimpleSetting(projectId: number, service: ScreeningSettingsServiceTypes, llmBased: boolean): Observable<SimpleQueryDTO> {
    if (!projectId) {
      throw new Error('ProjectId is required');
    }
    let params = new HttpParams()
      .set('service', service.toString())
      .set('llmBased', llmBased.toString());

    return this.http.get<SimpleQueryDTO>(`${this.apiUrl}/${projectId}/screening-settings/simple`, {
      params: params,
    });
  }

  generateSetting(projectId: number): Observable<ScreeningSettingsDTO> {
    if (!projectId) {
      throw new Error('ProjectId is required');
    }
    return this.http.post<ScreeningSettingsDTO>(`${this.apiUrl}/${projectId}/screening-settings`, {});
  }

  updateSetting(projectId: number, id: number, setting: ScreeningSettingsDTO): Observable<ScreeningSettingsDTO> {
    if (!id) {
      throw new Error('Id is required');
    }
    if (!projectId) {
      throw new Error('ProjectId is required');
    }
    return this.http.put<ScreeningSettingsDTO>(`${this.apiUrl}/${projectId}/screening-settings/${id}`, setting);
  }

}

